import { ROUTES } from '@/const/route'
import { useAuthStore } from '@/stores/authStore'
import { useUserContextStore } from '@/stores/userContextStore'

/**
 * Navigation guard that checks if user has required roles
 * Redirects to no permission page if user lacks required roles
 * @param {RouteLocationNormalized} to - Target route
 * @param {RouteLocationNormalized} from - Current route
 * @returns {NavigationGuardReturn} Navigation result or undefined to proceed
 */
export async function requiresRole(to, from) {
  const authStore = useAuthStore()
  const userContextStore = useUserContextStore()

  const signedIn = await authStore.isUserSignedIn()

  if (!signedIn) {
    return undefined
  }

  // Skip role check for no permission page
  if (to.name === ROUTES.NO_PERMISSION) {
    return undefined
  }

  // Check if route requires specific roles
  if (to.meta.requiredRoles) {
    if (!userContextStore.hasFeatureRoles(to.meta.requiredRoles)) {
      return { name: ROUTES.NO_PERMISSION }
    }
  }

  return undefined
}
